import { StyleSheet, Platform } from 'react-native'
import type { Theme } from '../../../src/theme/getTheme'

export function getLandingNavMobileMenuStyles(theme: Theme) {
  return StyleSheet.create({
    mobileMenu: {
      borderTopWidth: 1,
      borderTopColor: theme.gray[300],
      paddingHorizontal: 16,
      paddingBottom: 12,
      backgroundColor: theme.background.primary,
    },
    mobileNavLink: {
      paddingVertical: 15,
      borderBottomWidth: 1,
      borderBottomColor: theme.gray[300],
    },
    mobileNavLinkPressed: {
      backgroundColor: theme.gray[200],
    },
    mobileNavLinkText: {
      fontFamily: Platform.OS === 'web' ? '"Inter", system-ui, sans-serif' : undefined,
      fontSize: 16,
      fontWeight: '600',
      color: theme.black,
    },
    mobileNavLinkSignOut: {
      color: theme.gray[600],
      fontWeight: '500',
    },
  })
}
